const homePage = {
  "home.navigation.career.title": "Career",
  "home.navigation.career.subtitle": "Continue Your Journey",
  "home.navigation.challenges.title": "Challenges",
  "home.navigation.challenges.subtitle": "Brace Yourself",
  "home.navigation.practice.title": "Practice",
  "home.navigation.practice.subtitle": "Improve Your Game",
  "home.navigation.matchplay.title": "Match Play",
  "home.navigation.matchplay.subtitle": "AI Training Mode",
  "home.navigation.locked": "Complete Bootcamp to unlock",
  "home.section.latest-challenges.title": "Latest Challenges",
  "home.navigation.guides.title": "Guides",
  "bootcamp.home.title": "Bootcamp Training",
  "bootcamp.home.description": "Complete each session to build your foundation and unlock the full training experience.",
};

const bootcampWelcome = {
  "bootcamp.welcome.title": "Welcome to Be Your Best! ⚽",
  "bootcamp.welcome.description":
    "You're in Bootcamp — your starting line. Complete these short sessions to learn about our metrics, calibrate your baseline BYB IQ, and unlock full training.",
  "bootcamp.welcome.start": "Start Bootcamp",
};

const bootcampFinished = {
  "bootcamp.finished.title": "Bootcamp completed!",
  "bootcamp.finished.description": "Continue your journey by exploring all game modes.",
};

export const vrHome = {
  ...homePage,
  ...bootcampWelcome,
  ...bootcampFinished,
};
